import { msg } from 'gt-react';
import { ArrowsLeftRightIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
} from '../../route';

const TransferOrderStatusPage = lazyRouteComponent(
  () => import('./TransferOrderStatusPage'),
  'TransferOrderStatusPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/procurement/transfer-order-status',
  staticData: {
    app: {
      nav: {
        label: msg('Transfer Order Status', {
          context: 'sidebar nav label, Procurement section',
        }),
        icon: <ArrowsLeftRightIcon className="h-4 w-4" weight="fill" />,
        group: 'Procurement',
        order: 27,
        groupOrder: 30,
        nestUnder: '/procurement/internal-transfers',
      },
      access: {
        modulesAnyOf: [ProductModule.PROCUREMENT],
        permissionsAllOf: [
          { action: Action.Read, subject: Subject.PurchaseOrder },
        ],
      },
    },
  },
  component: TransferOrderStatusPage,
  validateSearch: z.object({
    search: z.string().optional(),
    status: z.array(z.string()).optional(),
    originSystems: z.array(z.string()).optional(),
    divisionIds: z.array(z.uuid()).optional(),
    orderDateFrom: z.string().optional(),
    orderDateTo: z.string().optional(),
    sortBy: z.string().optional(),
    sortDirection: z.enum(['asc', 'desc']).optional(),
    page: z.number().optional(),
    pageSize: z.number().optional(),
  }),
  loader: () => ({
    crumb: msg('Transfer Order Status', { context: 'page breadcrumb' }),
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.PROCUREMENT],
    });
  },
});
